/** seconds = 00, milliseconds = 000 */
export default function getCurrentJSDateWithoutSeconds(): Date {
  const date = new Date();
  date.setSeconds(0, 0);
  return date;
}
